<template>
<div class="content">
  <div class="button-box">
    <van-button type="primary" style="background: #FDD80D;border-color: #FDD80D;color: #282828" @click="goSubmit">首次提交</van-button>
    <van-button type="info" v-if="!verifyShow" style="background: #55BB3A;border-color:#55BB3A"  @click="goUpdate">更新资料</van-button>

  </div>
  <div class="code-box" v-if="verifyShow">
    <div class="code-title">请输入首次提交资料的凭证码进行验证：</div>
    <input v-model="codeNum" type="text" />
    <van-button type="info" style="background: #55BB3A;border-color:#55BB3A"  @click="goVerifyUpdate">验证</van-button>
  </div>

</div>
</template>

<script>
import { getCompanyReport, companyEdit, companyReportPost } from '@/api/company'
import {getWechat} from "@/api/zhibo";
const jweixin = require('jweixin-module');
export default {
  name: "applyFor",
  data(){
    return{
      codeNum:'',
      verifyShow:false,
      pic:''
    }
  },
  created() {
    let http = window.location.protocol+'//'
    let url = window.location.hostname // 获取当前访问（域名）
    this.pic = http+url+'/logo.jpg' //'https://jpzs-zst.itos.cn/logo.jpg'
    this.getShareInfo()
  },
  methods: {
    getShareInfo(){
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        // console.log('ios')
      } else {
        // console.log('安卓')
        pageUrl = location.href.split('#')[0]
      }

      const data = {
        liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
      }
      // console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          let weChat = res.data
          // console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['checkJsApi','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            const that = this
            // console.log('ready',that.desShare)
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              //是否支持分享
              jweixin.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
                success: function (res) {
                  console.log(res)
                }
              });
              let urlPath = location.href.split('#')[0]
              // alert("准备完毕，加载方法");
              //分享到朋友圈
              jweixin.updateTimelineShareData({
                title: '全球名优申请',   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: '',   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              });
              jweixin.onMenuShareTimeline({ // 旧版本
                title: '全球名优申请',   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: '',   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              })
              //分享给朋友
              jweixin.updateAppMessageShareData({
                title: '全球名优申请',
                desc:'  ',
                link: urlPath, // keyi
                imgUrl: '',
                success: function (n) {
                  console.log("分享成功", n);
                },
                complete: function (n) {
                  console.log(n);
                }
              });

              // 旧版本
              jweixin.onMenuShareAppMessage({
                title: '全球名优申请', // 分享标题
                desc:' ', // 分享描述
                link: urlPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: '', // 分享图标
                success: function (e) {
                  // 用户点击了分享后执行的回调函数
                  console.log('分享给朋友',e);
                }
              });


            })
          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    getDesReport(){
      var data = {
        code: this.codeNum
      }
      getCompanyReport(data).then(res => {

        if (res.code==200){
          console.log(res)
          var data = res.data
          console.log(data)
          this.$router.push({path:'/applyForEdit',query: {code:this.codeNum}})
        } else {
          this.$toast(res.message)
        }
      })
    },
    goSubmit(){ // 首次提交
      this.$router.push('/applyForCheck');
    },
    goUpdate(){ // 更新
      this.verifyShow = true

      // if (this.verifyShow==true){
      //   //this.$router.push('/applyForEdit');
      // }

    },
    goVerifyUpdate(){
      //this.$router.push('/applyForEdit');
      this.getDesReport()
    }
  }
}
</script>

<style lang="scss" scoped>
.button-box{
  margin-top: 350px;
}
.van-button{
  display: block;margin: 40px auto;width: 70%;
}
.code-box{
  margin: 50px 50px 0;border: 1px solid #cccccc;border-radius: 10px;
  .code-title{
    padding: 50px 0 40px;font-size: 30px;text-align: center;
  }
  input{
    height: 88px;line-height: 88px;font-size: 28px;border: none;width: 68%;padding: 0 10px;
    display: block;margin: 0 auto;
  }
}
</style>
